import { saveAs } from 'file-saver';
import axios from './axiosInterceptors';
import {
  ENDPOINTS,
  URL_FILTERS_PARAMS,
} from '../config';
import { ObjectType } from '../types/objectType';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const download = (blob: any, name: string) => {
  saveAs(blob, name);
  return { statusCode: 200 };
};

const downloadService = async (
  id: string,
  nombre: string,
  type = 'pdf',
) => {
  const result = await axios.get(
    `/v1/download/${type}/${id}`,
    { responseType: 'blob' },
  )
    .then((response: { status: number; data: any; }) => {
      if (response.status === 200) {
        return download(response.data, `cv-${nombre}.${type === 'docxEmp' ? 'docx' : type}`);
      }
      throw new Error(`Error downloading ${type}`);
    })
    .catch((e: any) => e);
  return result;
};

const downloadExcelService = async (
  nombre: string,
  filters: ObjectType,
  type = 'xlsb',
) => {
  const filtersFromReduxStorage = { ...filters };
  // get all results
  filtersFromReduxStorage.limitWorkers = 'all';
  filtersFromReduxStorage.limitCivilWorks = 'all';
  let paramsToAdd = '';
  const urlFilterParams = Object.values(URL_FILTERS_PARAMS);
  Object.keys(filtersFromReduxStorage).forEach((key) => {
    if (
      filtersFromReduxStorage[key]
      && (
        ((typeof (filtersFromReduxStorage[key]) === 'string') && filtersFromReduxStorage[key].length > 0)
        || (typeof (filtersFromReduxStorage[key]) === 'number')
      )
    ) {
      urlFilterParams.forEach((filterParam) => {
        if (filterParam.includes(`{${key}}`)) {
          const textToAdd = filterParam.replace(`{${key}}`, filtersFromReduxStorage[key]);
          paramsToAdd += textToAdd;
        }
      });
    }
  });
  const result = await axios.post(
    `/v1/download/excel/${nombre}${paramsToAdd}`,
  )
    .then((response: { status: number; data: any; }) => ({
      ...response.data,
      statusCode: response.status,
      fileType: type,
    }))
    .catch((e: any) => {
      // eslint-disable-next-line no-console
      console.log('Error during download:', e);
      return { statusCode: 500, e };
    });
  return result;
};

const listExcelExports = async () => {
  const response = await axios.get(ENDPOINTS.v1.downloadExports);
  return response.data;
};

const getExcelExport = async (id: string) => {
  const response = await axios.get(`${ENDPOINTS.v1.downloadExports}/${encodeURIComponent(id)}`);
  return response.data;
};

const downloadExcelExport = async (id: string, fileName: string) => {
  const response = await axios.get(
    `${ENDPOINTS.v1.downloadExports}/${encodeURIComponent(id)}/download`,
    { responseType: 'blob' },
  );
  return download(response.data, fileName);
};

const deleteExcelExport = async (id: string) => {
  const response = await axios.delete(
    `${ENDPOINTS.v1.downloadExports}/${encodeURIComponent(id)}`,
  );
  return response;
};

export default {
  downloadService,
  downloadExcelService,
  listExcelExports,
  getExcelExport,
  downloadExcelExport,
  deleteExcelExport,
};
